import { KVMessageDef } from './index'

export function getBatchScreenshotProgressMessage() {
  return {
    type: 'batchScreenshotProgress',
    requiredData: [
      'requestId',
      'totalJobs',
      'completed',
      'failed',
      'currentAnnotation',
      'totalAnnotations',
      'currentLayer',
      'totalLayers',
    ],

    callback: (json: Record<string, unknown>) => {
      const requestId = json.requestId as string
      const totalJobs = json.totalJobs as number
      const completed = json.completed as number
      const failed = json.failed as number
      const currentAnnotation = json.currentAnnotation as number
      const totalAnnotations = json.totalAnnotations as number
      const currentLayer = json.currentLayer as number
      const totalLayers = json.totalLayers as number

      const progress =
        totalJobs > 0 ? Math.round((completed / totalJobs) * 100) : 0

      // eslint-disable-next-line no-console
      console.log(
        `[BatchScreenshot] Progress: ${progress}% (${completed}/${totalJobs}) - Layer ${currentLayer}/${totalLayers}, Annotation ${currentAnnotation}/${totalAnnotations}, Failed: ${failed}`
      )

      // Dispatch custom event for UI components to listen to
      window.dispatchEvent(
        new CustomEvent('batchScreenshotProgress', {
          detail: {
            requestId,
            totalJobs,
            completed,
            failed,
            currentAnnotation,
            totalAnnotations,
            currentLayer,
            totalLayers,
            progress,
          },
        })
      )
    },
  } as KVMessageDef
}
